import { OFFICE_DATA } from './common/constants/contactInfoData';

export const getInitialState = (env: any, officeTLD: string) => ({
    infoOffice: OFFICE_DATA[officeTLD],
    infoTLD: {
        press_email: env.localeInfo.press_email,
        contact_us_url: env.localeInfo.contact_us_url,
        sales_email: env.localeInfo.sales_email,
        contact_sales_phone_number: env.localeInfo.contact_sales_phone_number,
    },
});
